module.exports = "<div class=\"rewardsplus-bonus-points-container\">\r\n    <div class=\"rewardsplus-iconContainer\">\r\n        <img src=\"/images/trolley/icon-rewards-wow-logo.svg\">\r\n    </div>\r\n    <div class=\"rewardsplus-textContainer\">\r\n        <span class=\"rewardsplus-title\">{{ $ctrl.settings.everydayRewards.rewardsMembershipAppliedMessage }}</span><br>\r\n        <span class=\"rewardsplus-bonus-points-content\" ng-bind-html=\"$ctrl.renderMessage\"></span>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/cart/cart-bonus-points-rewards-plus.component.html
// module id = 192
// module chunks = 0 1